import { render, staticRenderFns } from "./CommonButton.vue?vue&type=template&id=fd9f24d0&scoped=true"
import script from "./CommonButton.vue?vue&type=script&lang=js"
export * from "./CommonButton.vue?vue&type=script&lang=js"
import style0 from "./CommonButton.vue?vue&type=style&index=0&id=fd9f24d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9f24d0",
  null
  
)

export default component.exports